import ListProcesses from "@/views/agro_exporter/quality_reports/process/ListProcesses.vue";
import ListTemplates from "@/views/agro_exporter/quality_reports/process/ListTemplates.vue";
import ShowTemplateMainRep from "@/views/agro_exporter/quality_reports/process/ShowTemplateMainRep.vue";


import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "quality_reports",
  permission: "process",
});

export default [
  {
    path: "/ae/:agro_exporter_id/quality_reports/process/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/process/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/process/list_templates/:agro_exporter_process_id",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/process/:agro_exporter_process_id/show_template_rep/:quality_template_main_rep_id",
    name: routeName("show_template_rep"),
    component: ShowTemplateMainRep,
    props: true,
    meta: META
  }
];
